import * as React from 'react';
import responsive from './skins/responsive';
import { st, classes } from './BaseUINextContext.st.css';
const BaseUiNextContext = React.createContext({});
const BaseUiNextConsumer = BaseUiNextContext.Consumer;
/**
 * A wrapper component for an app to hold cross library global configuration such as theme, locale, etc.
 */
class BaseUiNextProvider extends React.PureComponent {
    getClassName() {
        const { theme, darkMode, madefor, className } = this.props;
        return st(classes.root, { madefor }, className, theme === 'responsive' && responsive({ darkMode }));
    }
    getDataAttributes() {
        const { theme, darkMode, madefor } = this.props;
        return {
            'data-theme': theme,
            'data-dark-mode': darkMode,
            'data-madefor': madefor,
        };
    }
    getValue() {
        const { theme, darkMode, madefor } = this.props;
        return {
            theme,
            darkMode,
            madefor,
            appFlagsClass: this.getClassName(),
            appDataAttributes: this.getDataAttributes(),
        };
    }
    render() {
        const { dataHook, as = 'span', children } = this.props;
        return (React.createElement(BaseUiNextContext.Provider, { value: this.getValue() }, React.createElement(as, Object.assign({ className: this.getClassName(), 'data-hook': dataHook }, this.getDataAttributes()), children)));
    }
}
BaseUiNextProvider.displayName = 'BaseUiNextProvider';
BaseUiNextProvider.defaultProps = {
    as: 'span',
    darkMode: false,
    madefor: false,
};
export { BaseUiNextContext, BaseUiNextConsumer, BaseUiNextProvider };
//# sourceMappingURL=BaseUINextContext.js.map